module.exports = __webpack_public_path__ + "img/used3.4b280ec3.png";